import { PageHeader, Card, MarkdownView, EmptyState } from '../ui';
import { useBinder } from '../../lib/useBinder';
import { useFocusHighlight, focusId } from '../../lib/useFocusHighlight';
import { ShowButton } from '../common/ShowButton';
import shared from './sections.module.css';
import styles from './CluesSection.module.css';

function optionalImage(entity: Record<string, unknown>): string | undefined {
  return typeof entity.image === 'string' ? entity.image : undefined;
}

/** Clues grouped by their author/source. */
export function CluesSection() {
  const ctx = useBinder();
  useFocusHighlight();
  if (!ctx) return null;
  const { adventure, instance, state, slug } = ctx;
  void state;

  const groups = adventure.clues.reduce<Map<string, typeof adventure.clues>>((acc, clue) => {
    const author = clue.author || 'Indizi';
    const list = acc.get(author) ?? [];
    list.push(clue);
    acc.set(author, list);
    return acc;
  }, new Map());

  return (
    <div>
      <PageHeader eyebrow="Indizi" title="Indizi e rivelazioni" />

      {!adventure.clues.length ? (
        <EmptyState
          icon="🔎"
          title="Nessun indizio"
          description="Questa avventura non contiene indizi preparati."
        />
      ) : (
        Array.from(groups.entries()).map(([author, clues]) => (
          <section key={author} className={shared.sectionBlock}>
            <h2 className={styles.groupTitle}>{author}</h2>
            <div className={shared.grid}>
              {clues.map((clue) => (
                <Card key={clue.id ?? clue.title} id={focusId(clue.id)}>
                  <div className={shared.entityHead}>
                    <span className={shared.entityIcon} aria-hidden>
                      {clue.icon ?? '🔎'}
                    </span>
                    <h3 className={shared.entityName}>{clue.title}</h3>
                    <div className={shared.cardActions}>
                      <ShowButton
                        slug={slug}
                        image={optionalImage(clue)}
                        title={clue.title}
                        instanceId={instance.id}
                      />
                    </div>
                  </div>

                  {clue.location && (
                    <div className={shared.tagRow}>
                      <span className={shared.chip}>📍 {clue.location}</span>
                    </div>
                  )}

                  {clue.text && <MarkdownView>{clue.text}</MarkdownView>}
                </Card>
              ))}
            </div>
          </section>
        ))
      )}
    </div>
  );
}
